<template>
  <section class="platform-target">
    <div class="container">
      <h2 class="section-title">Как понять, какой тариф мне подойдет?</h2>
      <div class="target-grid">
        <div class="target-card" v-for="(item, index) in targets" :key="index">
          <h3>{{ item.name }}</h3>
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const targets = [
  {
    title:
      "Для индивидуальных предпринимателей и фрилансеров, которым нужно проверить 1-2 контрагента в месяц",
    name: "Free",
  },
  {
    title:
      "Для малого бизнеса и закупщиков : базовая аналитика, отчёты, мониторинг",
    name: "Business",
  },
  {
    title:
      "Для юристов, закупщиков, отделов продаж : автоматизация, скоринг, API",
    name: "Premium",
  },
];
</script>

<style lang="scss">
.platform-target {
  background: #f5f7fa;
  padding: 64px 20px;

  .section-title {
    font-size: 45px;
    font-weight: 700;
    text-align: start;
    margin-bottom: 64px;
    color: rgba(62, 62, 62, 1);
    max-width: 560px;

    @media (max-width: 768px) {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }

  .target-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin: 0 auto;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .target-card {
    background: white;
    border-radius: 30px;
    padding: 24px;
    box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
    display: flex;
    flex-direction: column;
    gap: 12px;

    h3 {
      font-size: 22px;
      font-weight: 700;
      color: rgba(62, 62, 62, 1);
      margin: 0;

      @media (max-width: 768px) {
        font-size: 18px;
      }
    }

    p {
      font-size: 14px;
      color: rgba(62, 62, 62, 0.6);
      margin: 0;
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }

    .icon-wrapper {
      width: 48px;
      height: 48px;
      background: rgba(0, 199, 130, 1);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;

      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
